import { useMutation } from 'react-query';

import { patchImageToClient } from 'api/clients/patchImageToClient';

const useEditImageToClient = () => {
  const { mutate: editImageToClient, isLoading } = useMutation(patchImageToClient);

  return { editImageToClient, isLoading };
};

export default useEditImageToClient;
